export const D08 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales Growth & Performance",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Product Name',
                        "columnName": 'ItemName',
                        "width": '400px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Sales (PESO)',
                        "columnName": 'ActualSales(Value)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'LYSales (PESO)',
                        "columnName": 'LYSales(Value)',
                        "width": '160px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": '% Growth (PESO)',
                        "columnName": 'Growth(Value)',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Target (PESO)',
                        "columnName": 'TargetSales(Value)',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Variance (PESO)',
                        "columnName": 'Variance(Value)',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": '% Performance (PESO)',
                        "columnName": 'Performance(Value)',
                        "width": '210px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Sales (UNIT)',
                        "columnName": 'ActualSales(Qty)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": 'LYSales (UNIT)',
                        "columnName": 'LYSales(Qty)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": '% Growth (UNIT)',
                        "columnName": 'Growth(Qty)',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Target (UNIT)',
                        "columnName": 'TargetSales(Qty)',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": '% Performance (UNIT)',
                        "columnName": 'Performance(Qty)',
                        "width": '210px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": 'ItemName',
                "endpoint": "D08",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "DistrictManagerCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "ItemName",
                        "visuals": [
                            {
                                "title": "District",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "District",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'District',
                                                            "columnName": 'DistrictName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Sales (PESO)',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales (PESO)',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '160px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": '% Growth (PESO)',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        },
                                                        {
                                                            "name": 'Target (PESO)',
                                                            "columnName": 'TargetSales(Value)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Variance (PESO)',
                                                            "columnName": 'Variance(Value)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": '% Performance (PESO)',
                                                            "columnName": 'Performance(Value)',
                                                            "width": '210px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        },
                                                        {
                                                            "name": 'Sales (UNIT)',
                                                            "columnName": 'ActualSales(Qty)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true
                                                        },
                                                        {
                                                            "name": 'LYSales (UNIT)',
                                                            "columnName": 'LYSales(Qty)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true
                                                        },
                                                        {
                                                            "name": '% Growth (UNIT)',
                                                            "columnName": 'Growth(Qty)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        },
                                                        {
                                                            "name": 'Target (UNIT)',
                                                            "columnName": 'TargetSales(Qty)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": '% Performance (UNIT)',
                                                            "columnName": 'Performance(Qty)',
                                                            "width": '210px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'RegionCode',
                                                    "endpoint": "D08.3",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "DistrictManagerCode", "value": "" },
                                                        { "key": "ItemName", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {

                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                "title": "PMR",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "PMR",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'PMR Code',
                                                            "columnName": 'AgentCode',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Employee Code',
                                                            "columnName": 'EmployeeCode',
                                                            "width": '160px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'PMR Name',
                                                            "columnName": 'AgentName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Sales (PESO)',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales (PESO)',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '160px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": '% Growth (PESO)',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        },
                                                        {
                                                            "name": 'Target (PESO)',
                                                            "columnName": 'TargetSales(Value)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Variance (PESO)',
                                                            "columnName": 'Variance(Value)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": '% Performance (PESO)',
                                                            "columnName": 'Performance(Value)',
                                                            "width": '210px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        },
                                                        {
                                                            "name": 'Sales (UNIT)',
                                                            "columnName": 'ActualSales(Qty)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true
                                                        },
                                                        {
                                                            "name": 'LYSales (UNIT)',
                                                            "columnName": 'LYSales(Qty)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true
                                                        },
                                                        {
                                                            "name": '% Growth (UNIT)',
                                                            "columnName": 'Growth(Qty)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        },
                                                        {
                                                            "name": 'Target (UNIT)',
                                                            "columnName": 'TargetSales(Qty)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": '% Performance (UNIT)',
                                                            "columnName": 'Performance(Qty)',
                                                            "width": '210px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'AgentName',
                                                    "endpoint": "D08.2",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "DistrictManagerCode", "value": "" },
                                                        { "key": "ItemName", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {

                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        }
    }
}